import { Component } from '@angular/core';
import { DemoRequestService } from 'src/app/dialogs/demo-choice-dialog/demo-request.service';

@Component({
  selector: 'app-ai-candidate-sourcing-section',
  templateUrl: './ai-candidate-sourcing-section.component.html',
  styleUrls: ['./ai-candidate-sourcing-section.component.scss'],
})
export class AiCandidateSourcingSectionComponent {
  constructor(private demoRequestService: DemoRequestService) {}

  openDemoChoice() {
    this.demoRequestService.openDemoChoice();
  }
}
